import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { ILoyaltyHowItWorks } from './ILoyaltyHowItWorks';
import HowItWorksStepItem from './HowItWorkStepItem';
import { classes } from '~utils/Classes';
import printAreasByItemNumber from '~utils/gridAreasByItemNumber';
import { marketingPageSections as ms } from '~views/marketing-page/sections';

export const TEST_ID_HOW_IT_WORKS = 'loyalty-marketing-page-how-it-works';
const howItWorksWrapperClass = classes('loyalty-marketing-page-how-it-works-wrapper');
const howItWorksClass = classes('loyalty-marketing-page-how-it-works');
const howItWorksHeaderClass = classes('how-it-works-header');
const howItWorksSubheaderClass = classes('how-it-works-subheader');
const howItWorksStepsClass = classes('how-it-works-step-wrapper');

const HowItWorksWrapper = styled.div<{ backgroundColor: string; textColor: string }>`
    grid-area: ${ms.howItWorks};
    background-color: ${({ backgroundColor }) => `#${backgroundColor}`};
    color: ${({ textColor }) => `#${textColor}`};
`;
const HowItWorksSectionWrapper = styled.div`
    grid-area: HowItWorksSectionWrapper;
`;

const HowItWorksHeaderWrapper = styled.div`
    grid-area: MarketingPageHowItWorksHeader;
`;

const HowItWorksSubheaderWrapper = styled.div`
    grid-area: MarketingPageHowItWorksSubheader;
`;

const HowItWorksStepsWrapper = styled.div<{ stepsItems: number }>`
    display: grid;
    grid-template-areas: ${({ stepsItems }) => printAreasByItemNumber(stepsItems)};
    justify-items: center;
`;

export const HowItWorks = observer(function HowItWorksSection({ howItWorks }: ILoyaltyHowItWorks) {
    return (
        <HowItWorksWrapper
            data-test-id={TEST_ID_HOW_IT_WORKS}
            backgroundColor={howItWorks.sectionBackground.hex}
            textColor={howItWorks.textColor.hex}
            className={howItWorksWrapperClass}
        >
            <HowItWorksSectionWrapper className={howItWorksClass}>
                <HowItWorksHeaderWrapper
                    className={howItWorksHeaderClass}
                    dangerouslySetInnerHTML={{ __html: howItWorks.header }}
                />
                <HowItWorksSubheaderWrapper
                    className={howItWorksSubheaderClass}
                    dangerouslySetInnerHTML={{ __html: howItWorks.subheader }}
                />
                <HowItWorksStepsWrapper
                    className={howItWorksStepsClass}
                    stepsItems={howItWorks.stepsItems.length}
                >
                    {howItWorks.stepsItems.map((val, index) => (
                        <HowItWorksStepItem key={val.stepNumber} data={val} />
                    ))}
                </HowItWorksStepsWrapper>
            </HowItWorksSectionWrapper>
        </HowItWorksWrapper>
    );
});
